<template>
    <el-container class="approval-template">
        <el-aside v-if="isDesign && isShowLeft" width="200px">
            <el-header height="35px">业务分类</el-header>
            <BusinessTree
                v-if="isShowTree"
                :data="treeData"
                :defaultProps="defaultProps"
                @nodeClick="handleTreeNode"
            />
        </el-aside>
        <SideLeftTree v-if="isDesign"  @changeLeftTree="setShowleftList"/>
        <el-main >
            <div class="tools-bar">
                <div class="tools-search" @keyup.enter="handleSearch">
                    <el-form :inline="true" class="demo-form-inline">
                       <el-form-item v-if="isDesign" label="审批类型" >
                         <el-input maxlength="60" style="width: 150px; " disabled v-model.trim="searchParams.busiTypeName">
                         </el-input>
                       </el-form-item>
                       <el-form-item v-else label="审批类型">
                            <BusinessTree
                                ref="treeChild"
                                v-if="isShowTree"
                                :popover="true"
                                :data="treeData"
                                :defaultProps="defaultProps"
                                defaultClass="business-tree-form"
                                @nodeClick="handleTreeNode"
                            />
                        </el-form-item>
                        <el-form-item label="模板名称">
                          <el-input maxlength="100" v-model.trim="searchParams.templateName" placeholder="">
                              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                          </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-if="isDesign" class="tools-btn-group">
                    <el-badge class="badge-item" v-permission="permission.setAuthApprovalTemplateBtn">
                        <el-button icon="el-icon-user-solid" type="primary" title="全部授权，就是将所有审批模板全部授权给选择的人员。增量式授权，不会影响原有的授权。" @click="handleSetAllAuthProcessPop">全部授权</el-button>
                    </el-badge>
                    <el-badge class="badge-item" v-permission="permission.setAuthApprovalTemplateBtn">
                        <el-button icon="el-icon-user" type="primary" title="取消全部授权，就是清空指定人员的所有已授权模板的权限，不影响其他人员。" @click="handleCancelAllAuthProcessPop">取消全部授权</el-button>
                    </el-badge>
                    <el-badge class="badge-item" v-permission="permission.setAuthApprovalTemplateBtn">
                        <el-button icon="iconfont icon-other-piliang" title="批量授权，批量将选择的审批模板授权给批量选择的人员"  type="primary" @click="batchAuth">批量授权</el-button>
                    </el-badge>
                    <el-badge class="badge-item" v-permission="permission.addApprovalTemplateBtn">
                        <el-button icon="el-icon-circle-plus" type="primary" @click="handleAdd('')">添加</el-button>
                    </el-badge>
                </div>
                <div v-if="!isDesign" class="tools-btn-group">
                     <!-- <div style="cursor:pointer;" @click.stop="linkToApprovalTemplatePushPage()">
                        <span class="tag-link span-line">帮我们完善审批流模板仓库</span>
                    </div> -->
                </div>
            </div>
              <el-table :data="approvalTemplateList" :border="true" v-loading="loading" :height="tableAutoHeight()" style="margin-top:-10px" @selection-change="handleSelectionChange">
                <el-table-column
                  v-if="isSelect"
                  type="selection"
                  width="55">
                </el-table-column>
                  <el-table-column
                    label="模板名称"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        <span style="font-weight: 700;color:#303133;font-size:16px;">{{ scope.row.templateName }}</span>
                    </template>
                  </el-table-column>
                   <el-table-column
                      v-if="!isDesign"
                      prop="busiTypeName"
                      width="100"
                      label="审批类型"
                      align="center"
                    >
                  </el-table-column>
                   <el-table-column
                    label="发布状态"
                    width="90">
                    <template slot-scope="scope">
                       <el-tag type="success" v-if="scope.row.templateState==1">已发布</el-tag>
                       <el-tag type="info"  v-else>未发布</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="审批流顺序"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-steps v-if="scope.row.approvalMethod != 2 && scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                            <el-step v-for="(item, index) in scope.row.users" :key="index" :title="item.trueName"></el-step>
                        </el-steps>
                        <el-steps v-if="scope.row.approvalMethod == 2 && scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                            <el-step v-for="(item, index) in scope.row.approvalList"  :key="index" align-center >
                                <el-breadcrumb v-if="item && item.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                    <el-breadcrumb-item  v-for="(user, i) in item" :key="i">{{user.trueName}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </el-step>
                        </el-steps>
                        <el-steps v-if="scope.row.approvalMethod == 3 && scope.row.approvePeopleList.length>0" :active="scope.row.approvePeopleList.length" align-center>
                            <el-step v-for="(item, index) in scope.row.approvePeopleList"  :key="index" align-center >
                                <el-breadcrumb v-if="item.approvePeoples && item.approvePeoples.length > 0" slot="title" :separator="(item.approveWay == 2?'+':'/')">
                                    <el-breadcrumb-item  v-for="(user, i) in item.approvePeoples" :key="i">{{user.approvePeopleType=='user'?user.selectedUserName:user.fieldName}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </el-step>
                        </el-steps>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="已授权"
                    v-if="showAuthUserColumn"
                    :show-overflow-tooltip="true"
                    align="left"
                    prop="processServiceUserNames"
                    width="130">
                  </el-table-column>
                  <el-table-column align="center" label="操作" fixed="right" width="200">
                    <template slot-scope="scope">
                       <template v-if="isSelect">
                        <el-badge  class="badge-item">
                          <el-button size="mini" style="margin-left:-6px" icon="el-icon-view" title="预览" circle @click="handleViewTemplate(scope.row)"></el-button>
                        </el-badge>
                       </template>
                       <template v-else>
                         <template v-if="!isDesign">
                          <el-button v-if="scope.row.templateState==1" type="primary" title="发起审批" plain @click="handleStartApproval(scope.row)">发起审批</el-button>
                        </template>
                         <template v-if="isDesign">
                              <el-badge class="badge-item" v-permission="permission.modifiedApprovalTemplateBtn">
                                <el-button type="primary" size="mini" icon="el-icon-edit-outline" title="修改" circle @click="handleEdit(scope.row)"></el-button>
                              </el-badge>
                              <el-badge class="badge-item" v-permission="permission.copyApprovalTemplateBtn">
                                <el-button type="primary" size="mini" icon="el-icon-tickets" title="复制" circle @click="handleEdit(scope.row,true)"></el-button>
                              </el-badge>
                              <el-badge class="badge-item" v-permission="permission.deleteApprovalTemplateBtn">
                                <el-button type="danger" size="mini" icon="el-icon-delete" title="删除" circle @click="handleDelete(scope.row)"></el-button>
                              </el-badge>
                              <el-badge class="badge-item" v-permission="permission.publishApprovalTemplateBtn">
                                <el-button v-if="scope.row.templateState==0"  type="success" size="mini" icon="el-icon-caret-right" title="发布" circle @click="handlePublish(scope.row,1)"></el-button>
                                <el-button v-if="scope.row.templateState==1"  type="info" size="mini" icon="el-icon-caret-right" title="停用" circle @click="handlePublish(scope.row,0)"></el-button>
                              </el-badge>
                              <el-badge class="badge-item" v-permission="permission.setAuthApprovalTemplateBtn">
                                <el-button type="success" size="mini" icon="el-icon-user-solid" title="授权" circle @click="handleSetAuthProcessPop(scope.row)"></el-button>
                              </el-badge>
                        </template>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
                 <el-row type="flex" justify="end">
                    <el-pagination
                        background
                        layout="total,sizes, prev, pager, next"
                        :total="page.totalPageNum"
                        :current-page="page.currentPage"
                        :page-size="page.pageSize"
                        :page-sizes="[5, 10, 20, 30, 50]"
                        @size-change="queryFormDataSizes"
                        @current-change="queryFormData"
                    />
                </el-row>
          </el-main>
          <el-dialog
              title="审批流模板"
              width="90%"
              top="1vh"
              :close-on-click-modal="false"
              v-if="isShowTemplate"
              :visible.sync="isShowTemplate"
              @close="_getFormData"
              append-to-body
              >
              <ApprovalTemplatePop ref="approvalTemplatePop" :templateInfo="templateInfo" :isRead="isRead"/>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowTemplate=false">取 消</el-button>
                  <el-button v-if="!isRead"  type="primary" @click="handleEditTemplateInfo">保 存</el-button>
              </span>
          </el-dialog>
          <el-dialog
              :title="approvalTitle"
              width="80%"
              top="0vh"
              class="approval-pop-dialog"
              custom-class="approval-pop-dialog"
              :visible.sync="isShowApprovalPop"
              :fullscreen="true"
              append-to-body
              >
              <ApprovalPop
                    :key="loadTimer"
                    ref="approvalPop"
                    :instances="{id:approvalInstanceId,formObj: {}}" :isInstance="false" :approvalTemplateObj="templateInfo" :busiProcessInstanceId="_busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :belongProcessFlag="belongProcessFlag" :formDataFromBusiness="formInfo" :taskParam="taskParam" :isDraft="true" :processModelFormsObj="processModelFormsObj"/>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="handleSaveDraft" type="success">保存草稿</el-button>
                  <el-button @click="handleApply" :loading="startApprovalloading" type="primary">发起审批</el-button>
                  <el-button @click="isShowApprovalPop=false" type="info">取 消</el-button>
              </span>
          </el-dialog>
          <el-dialog
            title="流程选择窗口"
            :visible.sync="isShowProcessListDialog"
            width = "40%">
            <ProcessPop  :field="{}" ref="processSelect" :formData="{}" @nodeClick="selectTrigger"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowProcessListDialog = false" >取 消</el-button>
                <el-button  type="primary" @click="handleClickOk">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="审批流模板推送"
            append-to-body
            :visible.sync="isShowApprovalTemplatePushPage">
            <el-form  :model="selectTemplateInfo" size="mini" label-width="120px" class="message-form">
                <el-form-item label="模板名称:">
                    <!--<div class="message-item-pre message-item-content">
                        {{selectTemplateInfo.templateName}}
                    </div>-->
                     <ApprovalTemplateSelectPop  :field="{}" ref="templateSelect" :formData="{}" @nodeClick="selectTemplateTrigger"/>
                </el-form-item>
                <el-form-item label="温馨提示:">
                    <div class="message-item-pre message-item-content">
                        您的审批流模板将推送给我们客服，审核通过后，将会完善到我们的审批流模板仓库。后续会有相应奖励。
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleApprovalTemplatePushToCs()">提交</el-button>
                    <el-button type="info" @click="isShowApprovalTemplatePushPage=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            title="授权设置"
            :visible.sync="isShowAppDialog">
           <el-form size="mini" label-width="120px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="方案名称">
                            <el-input  disabled v-model="templateInfo.templateName" />
                        </el-form-item>
                    </el-col>
                     <el-col :span="12">
                        <el-form-item label="选择人员">
                            <el-input readonly v-model="selectedUser.selectedUserNames" @focus="chooseUser" ></el-input>
                            <UserOrgPop :key="loadTimer" :multiple="true" :isShowUserOrg='isShowUserOrg'  :selectedUser="selectedUser" ref="userOrgPop" @nodeClick="selectUserTrigger"  />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowAppDialog = false" >取 消</el-button>
                <el-button type="primary" @click="handleSetAuthProcess">{{this.isSetAuth > 0 ? "确定授权" : "取消授权"}}</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="审批流批量授权"
            v-if="isShowBatchApproveAuth"
            :visible.sync="isShowBatchApproveAuth"
            destroy-on-close
            width="90vw"
            top="2vh"
            >
            <ApproveBatchAuth ref="approveBatchAuth" :permission="permission" :treeData="treeData" :defaultProps="defaultProps" :approvalTemplateList="approvalTemplateList"></ApproveBatchAuth>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="handleSetBatchAuthProcess(0)">覆盖式授权</el-button>
              <el-button type="primary" @click="handleSetBatchAuthProcess(1)">增量式授权</el-button>
            </span>
        </el-dialog>
      </el-container>
</template>

<script>
    import { isEmpty } from 'lodash';
    import {
        getApprovalTemplateByFormData,
        getBusinessTreeList,
        saveApprovalTemplate,
        deleteApprovalTemplate,
        publishApprovalTemplate,
        getApprovalTemplateList,
        copyApprovalTemplateToCs,
        saveProcessServiceUserRelation,
        saveAllProcessServiceUserRelation,
        cancelAllProcessServiceUserRelation
    } from '@/data-model';
    import ApprovalTemplatePop from './ApprovalTemplatePop';
    import mixinsNav from '@/mixins/mixins-nav';
    // import ApprovalPop from '@/components/ApprovalPop';
    import ProcessPop from '@/components/ProcessPop';
    import ApprovalTemplateSelectPop from '@/components/ApprovalTemplateSelectPop';
    import ApproveBatchAuth from '@/components/ApproveBatchAuth/ApproveBatchAuth';
    import {
        CONST_PERMISSION_PROCESS_ADD_APPROVAL_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_MODIFIED_APPROVAL_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_COPY_APPROVAL_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_DELETE_APPROVAL_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_PUBLISH_APPROVAL_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_SET_AUTH_APPROVAL_TEMPLATE_BTN
    } from '@/common/constants';

    export default {
        components: {
            ApprovalTemplatePop,
            ProcessPop,
            ApprovalTemplateSelectPop,
            ApproveBatchAuth
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                isShowLeft: true,
                hasApplyUser: false,
                isShowBatchApproveAuth: false,
                saveApprovalloading: false,
                processServiceUserRelation: {
                    processServiceType: '1', // 0流程定义1审批流
                    processServiceId: '',
                    userId: ''// 多个以逗号隔开
                },
                isSetAuth: 1, // 0:取消授权，1：单模板确认授权，2：全部模板确认授权
                isShowUserOrg: false,
                isShowAppDialog: false,
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                selectedCopyUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                loadTimer: '',
                selectTemplateInfo: {
                    id: '',
                    templateName: ''
                },
                isShowApprovalTemplatePushPage: false,
                _busiProcessInstanceId: '',
                isShowProcessListDialog: false,
                startApprovalloading: false,
                isShowTemplate: false,
                isShowApprovalPop: false,
                loading: false,
                isShowTree: false,
                treeData: [],
                isRead: false,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                searchParams: {
                    busiType: '',
                    busiTypeName: '',
                    templateName: '',
                    templateState: null,
                    formId: ''
                },
                templateInfo: {
                    id: '',
                    templateName: '',
                    busiType: '',
                    busiTypeName: '',
                    remarks: '',
                    selectedUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    templateState: null,
                    forms: [],
                    users: [],
                    approvalList: [[]],
                    approvalUserGroupList: [],
                    dataOperate: {
                        dataSource: 2,
                        forms: []
                    },
                    orderMode: 0,
                    rejectMode: 0,
                    sendSms: 0,
                    clearApprovalUsers: 0,
                    durTime: 0,
                    warnDate: '',
                    selectedCopyUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    approvalMethod: 1, // 审批方法，1:普通审批，2:审批流节点或签审批
                    showAllMyApprovals: true,
                    approvePeopleList: [],
                    copyUserObj: ''
                },
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 5, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                approvalTitle: '',
                approvalTemplateList: [],
                templateIds: '',
                approvalInstanceId: '',
                multipleSelection: [],
                permission: {
                    addApprovalTemplateBtn: [ // 新增审批流模板
                        CONST_PERMISSION_PROCESS_ADD_APPROVAL_TEMPLATE_BTN
                    ],
                    modifiedApprovalTemplateBtn: [ // 修改审批流模板
                        CONST_PERMISSION_PROCESS_MODIFIED_APPROVAL_TEMPLATE_BTN
                    ],
                    copyApprovalTemplateBtn: [ // 复制审批流模板
                        CONST_PERMISSION_PROCESS_COPY_APPROVAL_TEMPLATE_BTN
                    ],
                    deleteApprovalTemplateBtn: [// 删除审批流模板
                        CONST_PERMISSION_PROCESS_DELETE_APPROVAL_TEMPLATE_BTN
                    ],
                    publishApprovalTemplateBtn: [// 发布审批流模板
                        CONST_PERMISSION_PROCESS_PUBLISH_APPROVAL_TEMPLATE_BTN
                    ],
                    previewApprovalTemplateBtn: [// 预览审批流模板
                        // CONST_PERMISSION_PROCESS_PREVIEW_APPROVAL_TEMPLATE_BTN
                    ],
                    startApplyBtn: [// 发起申请
                        // CONST_PERMISSION_PROCESS_PREVIEW_APPROVAL_TEMPLATE_BTN
                    ],
                    setAuthApprovalTemplateBtn: [// 授权
                        CONST_PERMISSION_PROCESS_SET_AUTH_APPROVAL_TEMPLATE_BTN
                    ]

                }
            };
        },
        created () {
            this._initPage();
        },
        computed: {
        },
        watch: {
        },
        props: {
            appId: {
                type: [Number, String],
                default: ''
            },
            taskParam: {// 任务对象,用于暂存
                type: Object
            },
            formInfo: {
                type: Object
            },
            isDesign: {
                type: Boolean,
                default: false
            },
            busiProcessInstanceId: {
                type: String
            },
            busiProcessInstanceName: {
                type: String
            },
            busiTaskInstanceId: {
                type: String
            },
            belongProcessFlag: {// 1我的流程，2我的任务
                type: Number,
                default: 0
            },
            resource: {// 1应用中心 2流程中心
                type: Number,
                default: 1
            },
            isSelect: {
                type: Boolean,
                default: false
            },
            startApproval: {// 是否是发起审批流，对selectedTemplate参数的补充。
                type: Boolean,
                default: false
            },
            selectedTemplate: {
                type: Array,
                default: () => { return []; }
            },
            showAuthUserColumn: {
                type: Boolean,
                default: false
            },
            processModelFormsObj: {
                type: Array
            },
            isReturnToNav: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            async _initPage () {
                this._busiProcessInstanceId = this.busiProcessInstanceId;
                if (this.formInfo != null) {
                    this.searchParams.formId = this.formInfo.formId;
                    this.searchParams.formValue = this.formInfo.formValue;
                } else {
                    let businessTreeList = await getBusinessTreeList();
                    this.treeData = businessTreeList;
                }
                this.isShowTree = true;
                this.handleSearch();
            },
            handleTreeNode (data, node, tree) {
                this.searchParams.busiType = data.id;
                this.searchParams.busiTypeName = data.label;
                this.handleSearch();
            },
            handleAdd () {
                let resetInfo = {
                    id: '',
                    templateName: '',
                    busiType: '',
                    busiTypeName: '',
                    remarks: '',
                    selectedUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    selectedCopyUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    templateState: null,
                    forms: [],
                    users: [],
                    approvalList: [],
                    approvalUserGroupList: [],
                    dataOperate: {
                        dataSource: 3,
                        forms: []
                    },
                    orderMode: 0,
                    rejectMode: 0,
                    sendSms: 0,
                    clearApprovalUsers: 0,
                    durTime: 0,
                    warnDate: '',
                    approvalMethod: 1, // 审批方法，1:普通审批，2:审批流节点或签审批
                    showAllMyApprovals: true
                };
                this.templateInfo = resetInfo;
                this.templateInfo.busiType = this.searchParams.busiType;
                this.templateInfo.busiTypeName = this.searchParams.busiTypeName;
                setTimeout(() => { // 默认回显值
                    this.$refs.approvalTemplatePop._initPage();
                }, 0);
                this.isShowTemplate = true;
            },
            async handleEditTemplateInfo () {
                this.saveApprovalloading = true;
                let chk = this.$refs.approvalTemplatePop.checkFormField();
                if (chk) {
                    // 审批人可以选填
                    if (this.templateInfo.approvalMethod === 2) {
                        if (this.templateInfo.approvalList.length > 0) {
                            let approUsers = [];
                            for (let index = 0, len = this.templateInfo.approvalList.length; index < len; index++) {
                                if (this.templateInfo.approvalList[index].length > 0) {
                                    for (let j = 0; j < this.templateInfo.approvalList[index].length; j++) {
                                        if (approUsers.indexOf(this.templateInfo.approvalList[index][j].userId) > -1) {
                                            this.messageTip('不同节点中的审批人员有重复，请重新设置！', 'error');
                                            return false;
                                        } else {
                                            approUsers.push(this.templateInfo.approvalList[index][j].userId);
                                        }
                                    }
                                    if (approUsers.length > 15) {
                                        this.messageTip('选择的审批人总数不能超过15人', 'warning');
                                        return false;
                                    }
                                } else {
                                    this.messageTip('审批流第' + (index + 1) + '节点无审批人，请添加至少1位审批人！', 'error');
                                    return false;
                                }
                            }
                        }
                    } else if (this.templateInfo.approvalMethod === 3) {
                        if (this.templateInfo.approvePeopleList.length > 15) {
                            this.messageTip('选择的审批人总数不能超过15人', 'warning');
                            return false;
                        }
                    } else {
                        if (this.templateInfo.selectedUser.selectedUserIds !== undefined) {
                            let userIds = this.templateInfo.selectedUser.selectedUserIds.split(',');
                            if (userIds.length > 15) {
                                this.messageTip('选择的审批人总数不能超过15人', 'warning');
                                return false;
                            }
                        }
                    }
                    this.templateInfo.selectedUserIds = this.templateInfo.selectedUser.selectedUserIds;
                    this.templateInfo.selectedUserNames = this.templateInfo.selectedUser.selectedUserNames;
                    // 抄送人校验
                    if (this.templateInfo.selectedCopyUser.selectedUserIds !== undefined) {
                        let copyUserIds = this.templateInfo.selectedCopyUser.selectedUserIds.split(',');
                        if (copyUserIds.length > 15) {
                            this.messageTip('选择的抄送人总数不能超过15人', 'warning');
                            return false;
                        }
                    }
                    this.templateInfo.copyUserIds = this.templateInfo.selectedCopyUser.selectedUserIds;
                    this.templateInfo.copyUserNames = this.templateInfo.selectedCopyUser.selectedUserNames;
                    if (this.templateInfo.selectedUserIds === '') {
                        this.templateInfo.users = [];
                    }
                    // console.log(this.templateInfo);
                    await saveApprovalTemplate(this.templateInfo);
                    await this._getFormData();
                    this.isShowTemplate = false;
                    setTimeout(() => {
                        this.saveApprovalloading = false;
                    }, 300);
                } else {
                    this.saveApprovalloading = false;
                }
            },
            handleSearch () {
                this.queryFormData(1);
            },
            queryFormData (currentPage) {
                this.page.currentPage = currentPage;
                this._getFormData();
            },
            queryFormDataSizes (pageSize) {
                this.page.pageSize = pageSize;
                this._getFormData();
            },
            async _getFormData () {
                // console.log(this.selectedTemplate);
                if (this.isSelect) {
                    this.page.pageSize = 500;
                }
                if (!isEmpty(this.selectedTemplate)) {
                    this.approvalTemplateList = this.selectedTemplate;
                    this.page = {
                        currentPage: 1,
                        pageSize: this.selectedTemplate.length,
                        totalPageNum: this.selectedTemplate.length
                    };
                    if (this.selectedTemplate.length === 1) {
                        this.handleStartApproval(this.selectedTemplate[0]);
                    }
                } else {
                    this.loading = true;
                    this.searchParams.appId = this.appId;
                    this.searchParams.templateState = !this.isDesign ? 1 : null;
                    if (this.approvalTemplateList && this.approvalTemplateList.length > 0) {
                        this.approvalTemplateList = [];
                    }
                    if (this.formInfo && this.formInfo.formId === '613087a8672244aca9758ffa766635cc') {
                        let param = {
                            formId: this.formInfo.formId,
                            formValue: this.formInfo.values
                        };
                        let curTemplate = await getApprovalTemplateByFormData(param);
                        this.approvalTemplateList.push(curTemplate);
                        if (this.approvalTemplateList.length > 0) {
                            // 转换showAllMyApprovals的值Integer为Boolean
                            if (this.approvalTemplateList && this.approvalTemplateList.length > 0) {
                                this.approvalTemplateList.forEach(element => {
                                    element.showAllMyApprovals = (element.showAllMyApprovals > 0);
                                });
                            }
                        }
                    } else {
                        let formData = await getApprovalTemplateList(Object.assign({}, {
                            currentPage: this.page.currentPage,
                            pageSize: this.page.pageSize
                        }, this.searchParams));
                        if (formData) {
                            this.approvalTemplateList = formData.data;
                            this.templateIds = formData.hasOwnProperty('otherData') ? formData.otherData.templeteIds : '';
                            this.page = {
                                currentPage: formData.currentPage,
                                pageSize: formData.pageSize,
                                totalPageNum: formData.totalPageNum
                            };
                            // 转换showAllMyApprovals的值Integer为Boolean
                            if (this.approvalTemplateList && this.approvalTemplateList.length > 0) {
                                this.approvalTemplateList.forEach(element => {
                                    element.showAllMyApprovals = (element.showAllMyApprovals > 0);
                                });
                            }
                        }
                    }
                    this.loading = false;
                    if (this.approvalTemplateList && this.approvalTemplateList.length === 1 && this.startApproval) {
                        this.handleStartApproval(this.approvalTemplateList[0]);
                    }
                    if (this.approvalTemplateList && this.approvalTemplateList.length < 1) {
                        this.$message({
                            message: '没有查询到授权的审批模型,请联系系统管理员授权审批模型',
                            type: 'warning'
                        });
                    }
                }
            },
            handleStartApproval (row) {
                // console.log(row);
                // console.log("============"+row.selectedUserIds);
                this.approvalTitle = '发起【' + row.templateName + '】审批申请';
                this.templateInfo = row;
                // this.templateInfo.templateName = '';
                this.templateInfo.remarks = '';
                this.templateInfo.selectedUser = {};
                if (!isEmpty(row.selectedUserIds)) {
                    // 真正发起审批时候再限制，此处先放开
                    /* if (row.selectedUserIds.indexOf(currentUserInfo.userId) !== -1) {
                        this.$message({message: '申请人不能和审批人一致', type: 'warning'});
                        return false;
                    } */
                    if (row.clearApprovalUsers) {
                        this.templateInfo.selectedUser.selectedUserIds = '';
                        this.templateInfo.selectedUser.selectedUserNames = '';
                        this.templateInfo.selectedUserIds = '';
                        this.templateInfo.selectedUserNames = '';
                    } else {
                        this.templateInfo.selectedUser.selectedUserIds = row.selectedUserIds;
                        this.templateInfo.selectedUser.selectedUserNames = row.selectedUserNames;
                    }
                } else { // 解决ApprovalPop页面selectedUser.selectedUserNames不能为空的rule提示异常
                    this.templateInfo.selectedUser.selectedUserIds = '';
                    this.templateInfo.selectedUser.selectedUserNames = '';
                }
                this.loadTimer = new Date().getTime();
                this.approvalInstanceId = this.generateUUID();
                // if (this.belongProcessFlag === 0) {
                //     this.isShowProcessListDialog = true;
                // }else {
                setTimeout(() => { // 默认回显值
                    this.$refs.approvalPop._initPage();
                }, 0);
                this.isShowApprovalPop = true;
                // }
            },
            handleViewTemplate (row) {
                // console.log(row);
                this.isRead = true;
                this.handleEdit(row);
            },
            handleEdit (row, isCopy) {
                // console.log(row);
                this.templateInfo = row;
                if (isCopy) {
                    this.templateInfo.id = '';
                    this.templateInfo.templateName = '';
                }
                this.templateInfo.selectedUser = {};
                this.templateInfo.selectedUser.selectedUserIds = row.selectedUserIds;
                this.templateInfo.selectedUser.selectedUserNames = row.selectedUserNames;

                this.templateInfo.selectedCopyUser = {};
                this.templateInfo.selectedCopyUser.selectedUserIds = row.copyUserIds;
                this.templateInfo.selectedCopyUser.selectedUserNames = row.copyUserNames;
                this.templateInfo.countersignUsers = row.hasOwnProperty('countersignUsers') ? row.countersignUsers : [];
                if (!this.templateInfo.approvalList) {
                    this.templateInfo.approvalList = [];
                    this.templateInfo.approvalUserGroupList = [];
                }
                if (!isEmpty(this.templateInfo.deptUserlinkData)) {
                    for (let i = 0; i < this.templateInfo.deptUserlinkData.length; i++) {
                        let cur = this.templateInfo.deptUserlinkData[i];
                        cur.id = this.generateUUID();
                    }
                }
                setTimeout(() => { // 默认回显值
                    this.$refs.approvalTemplatePop._initPage();
                }, 0);
                this.isShowTemplate = true;
            },
            handleDelete (row) {
                // console.log(row);
                this.$confirm(`您确定要删除审批流模板[ ${row.templateName} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    await deleteApprovalTemplate(row.id);
                    await this._getFormData();
                }).catch(() => {});
            },
            async handlePublish (row, templateState) {
                // console.log(row, templateState);
                await publishApprovalTemplate(row.id, templateState);
                await this._getFormData();
                this.isShowTemplate = false;
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            async handleSaveDraft () {
                // opType 操作模式：1 保存草稿 2发起审批
                let isToApproval = this.$refs.approvalPop.isToApproval();
                if (!isToApproval) {
                    return;
                }
                let isValid = await this.$refs.approvalPop.handelSaveForms(1);
                // console.log(isValid);
                if (!isValid) {
                    this.isShowApprovalPop = false;
                    sessionStorage.setItem('isShowApprovalDraft', true);
                    if (this.belongProcessFlag === 0) {
                        if (this.isReturnToNav) { // 返回客户端方的方法进行页面跳转或逻辑操作
                            this.$emit('handleNavPage');
                        } else {
                            this.navMyApproval();
                        }
                    } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                        this.$emit('closeApprovalTemplate', {index: '3'});
                    }
                }
            },
            async handleApply () {
                setTimeout(() => { // 默认回显值
                    let isToApproval = this.$refs.approvalPop.isToApproval();
                    if (!isToApproval) {
                        return;
                    }
                    this.hasApplyUser = this.$refs.approvalPop.hasApplyUser();
                    // console.log("审批人中含有申请人?"+this.hasApplyUser);
                    if (this.hasApplyUser) {
                        this.$confirm(`审批人中含有申请人,您确定要发起审批吗？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (res) => {
                            this.startApprovalloading = true;
                            let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                            if (!isValid) {
                                this.isShowApprovalPop = false;
                                // console.log("============="+this.belongProcessFlag);
                                if (this.belongProcessFlag === 0) {
                                    if (this.isReturnToNav) { // 返回客户端方的方法进行页面跳转或逻辑操作
                                        this.$emit('handleNavPage');
                                    } else {
                                        this.navMyApproval();
                                    }
                                } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                                    this.$emit('closeApprovalTemplate', {index: '0'});
                                    this.$emit('refreshTaskDetail');
                                }
                            }
                            this.startApprovalloading = false;
                        }).catch(() => {
                        });
                    } else {
                        // opType 操作模式：1 保存草稿 2发起审批
                        this.$confirm(`您确定要发起审批吗？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (res) => {
                            this.startApprovalloading = true;
                            let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                            if (!isValid) {
                                this.isShowApprovalPop = false;
                                // console.log("============="+this.belongProcessFlag);
                                if (this.belongProcessFlag === 0) {
                                    if (this.isReturnToNav) { // 返回客户端方的方法进行页面跳转或逻辑操作
                                        this.$emit('handleNavPage');
                                    } else {
                                        this.navMyApproval();
                                    }
                                } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                                    this.$emit('closeApprovalTemplate', {index: '0'});
                                    this.$emit('refreshTaskDetail');
                                }
                            }
                            this.startApprovalloading = false;
                        }).catch(() => {});
                    }
                }, 100);
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            selectTrigger (selected) { // 选择流程
                // console.log("======"+selected.id);
                this._busiProcessInstanceId = selected.id;
            },
            async handleClickOk () {
                // if (this._busiProcessInstanceId === '' || this._busiProcessInstanceId === null || this._busiProcessInstanceId === undefined) {
                //     this.messageTip('请先选择所属流程', 'warning');
                //     return false;
                // }
                this.isShowProcessListDialog = false;
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 默认回显值
                    this.$refs.approvalPop._initPage();
                }, 0);
                this.isShowApprovalPop = true;
                // console.log(this._busiProcessInstanceId);
            },
            selectTemplateTrigger (selected) { // 选择流程
                // console.log(selected);
                this.selectTemplateInfo.id = selected.id;
                this.selectTemplateInfo.templateName = selected.label;
            },
            linkToApprovalTemplatePushPage () {
                this.isShowApprovalTemplatePushPage = true;
            },
            async handleApprovalTemplatePushToCs () {
                if (isEmpty(this.selectTemplateInfo.id)) {
                    this.messageTip('请先选择要推送的审批流模板', 'warning');
                    return false;
                }
                this.isShowApprovalTemplatePushPage = false;
                await copyApprovalTemplateToCs(this.selectTemplateInfo.id);
            },
            handleSelectionChange (val) {
                if (this.isSelect) {
                    this.multipleSelection = val;
                    this.$emit('chooseApprovalTemplate', this.multipleSelection);
                }
            },
            handleSetAuthProcessPop (process) {
                this.templateInfo = process;
                this.processServiceUserRelation.processServiceId = process.id;
                this.processServiceUserRelation.userId = process.processServiceUserIds;
                this.selectedUser.selectedUserIds = process.processServiceUserIds;
                this.selectedUser.selectedUserNames = process.processServiceUserNames;
                this.isSetAuth = 1;
                this.isShowAppDialog = true;
            },
            handleSetAllAuthProcessPop () {
                this.templateInfo.id = this.templateIds;
                this.templateInfo.templateName = '全部审批流模板';
                this.processServiceUserRelation.processServiceId = this.templateIds;
                this.processServiceUserRelation.userId = '';
                this.selectedUser = {
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
                this.isSetAuth = 2;
                this.isShowAppDialog = true;
            },
            handleCancelAllAuthProcessPop () {
                this.templateInfo.id = this.templateIds;
                this.templateInfo.templateName = '全部审批流模板';
                this.processServiceUserRelation.processServiceId = this.templateIds;
                this.processServiceUserRelation.userId = '';
                this.selectedUser = {
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
                this.isSetAuth = 0;
                this.isShowAppDialog = true;
            },
            chooseUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.userOrgPop._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            selectUserTrigger (selected) {
                this.selectedUser = selected;
                this.processServiceUserRelation.userId = selected.selectedUserIds;
            },
            async handleSetAuthProcess () {
                if (this.isSetAuth == 2) {
                    await saveAllProcessServiceUserRelation(this.processServiceUserRelation);
                } else if (this.isSetAuth == 1) {
                    await saveProcessServiceUserRelation(this.processServiceUserRelation);
                } else {
                    await cancelAllProcessServiceUserRelation(this.processServiceUserRelation);
                }
                this.isShowAppDialog = false;
                this.handleSearch();
            },
            async handleSetBatchAuthProcess (saveType) {
                let obj = this.$refs.approveBatchAuth.buildParam();
                obj.processServiceType = '1';
                obj.saveType = saveType;
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await saveProcessServiceUserRelation(obj);
                this.isShowBatchApproveAuth = false;
                loading.close();
                this.handleSearch();
            },
            batchAuth () {
                this.isShowBatchApproveAuth = true;
            },
            setShowleftList (isShowLeft) {
                this.isShowLeft = isShowLeft;
            },
            tableAutoHeight () {
                if (this.resource === 1) {
                    return window.innerHeight - 230;
                } else if (this.resource === 2) {
                    return window.innerHeight - 200;
                }
            }
        }
    };
</script>


<style lang="less">
  .approval-template {
      .el-header {
          display: flex;
          justify-content: center;
          align-items: center;
      }
      .el-main {
          padding: 0;
      }

      .el-aside {
          border-right: 1px solid #dcdfe6;
      }
      // .approval-pop-dialog{
      //   .el-dialog__header{
      //     padding: 5px 20px 10px;
      //   }
      //   .el-dialog__footer{
      //     padding: 65px 20px 5px 5px;
      //   }
      //   .el-dialog__body{
      //     // height: 540px;
      //     padding: 5px 5px;
      //   }
      // }
      .el-dialog__wrapper{
        overflow:hidden;
      }
      .span-line{
        font-size: 14px;
        color:rgb(19, 206, 102);
      }
      .span-line:hover{
         text-decoration:underline;
      }
      .el-step__main .el-breadcrumb{
        display: inline-block;
        .el-breadcrumb__item{
            .el-breadcrumb__inner{
                color:#409eff;
                a:hover{
                    color:#409eff;
                }
            }
            .el-breadcrumb__separator{
                color:#409eff;
            }
        }

    }
  }
    .approval-pop-dialog{
        .el-dialog__footer{
            margin-top: 8px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessTemplate/ApprovalTemplate.vue